// routes/AppRoutes.js
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AppLayout from '../pages/AppLayout/AppLayout';
import Home from '../pages/home';
import { useContext } from 'react';
import { AuthContext } from '../contexts/Auth/Auth.Context';
import GuestLayout from '../pages/GuestLayout/GuestLayout';
import { LoginForm } from '../pages/login/LoginForm';
import { RegistrationForm } from '../pages/registration/RegistrationForm';
import { ForgotPassword } from '../pages/ForgotPassword';
import { ResetPassword } from '../pages/ResetPassword';
import GuestHome from '../pages/Guest/home';
import GetInvolved from '../pages/Guest/GetInvolved';
import ContactUs from '../pages/Guest/Contact';
import ReportIncident from '../pages/report-incident';
import UserDashboard from '../pages/home/UserDashboard';
import DatasetManagement from '../pages/home/Dashboard/DatasetManagement';
import Articles from '../pages/home/Dashboard/Articles';
import ProfileSettingsView from '../pages/home/Dashboard/ProfileSettingsView';
import AboutUs from '../pages/Guest/AboutUs';
import FeaturesPage from '../pages/Guest/Features';
import FAQs from '../pages/Guest/FAQs';
import PrecedentsPage from '../pages/Guest/CasePrecedents';
import ApiDocs from '../pages/Guest/ApiDocs';
import PlatformDocs from '../pages/Guest/PlatformDocs';
import CookieBanner from '../pages/Guest/sections/CookieBanner';

const AppRoutes = () => {
    const { state } = useContext(AuthContext);

    const AuthenticatedUser = () => {
        return (
          <Navigate to="/dashboard" />
        )
    }
    
      const UnauthenticatedUser = () => {
        return (
          <Navigate to="/" />
        )
      }

    return (
        <Router>
        <Routes>
            <Route path='/' element={<GuestHome />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path='/case-precedents' element={<PrecedentsPage />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path='/faqs' element={<FAQs />} />
            <Route path='/api-documentation' element={<ApiDocs />} />
            <Route path='/platform-docs' element={<PlatformDocs />} />
            <Route path="/report-incident" element={<ReportIncident />} />
            {/* Password reset always accessible (header/footer via GuestLayout) */}
            <Route element={<GuestLayout />}>
                <Route path='/accounts/reset-password' element={<ResetPassword />} />
            </Route>

            <Route path="/accounts" element={state.userToken === null ? <GuestLayout /> : <AuthenticatedUser />}>
                <Route index element={<GuestHome />} />
                <Route path='/accounts/login' element={<LoginForm />} />
                <Route path='/accounts/register' element={<RegistrationForm />} />
                <Route path='/accounts/forgot-password' element={<ForgotPassword />} />
            </Route>
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path='/home' element={state.userToken === null || state.userData?.role?.toLowerCase() === "user" ? <UnauthenticatedUser /> : <AppLayout />}>
                <Route index element={<Home />} />
                <Route path="/home/settings" element={<ProfileSettingsView />} />
                <Route path="/home/documentation" element={<p>Coming Soon</p>} />
            </Route>
        </Routes>
        {/* Global whistleblower banner — shows on every public page, hides itself on the app */}
        <CookieBanner />
    </Router>
    )
};

export default AppRoutes;
